'use client';

import { createContext } from 'react';
import { ConfirmOptions } from '.';

export default createContext<(options?: ConfirmOptions) => Promise<string | undefined>>(
  () => undefined,
);
